export default __webpack_public_path__ + "static/cyber-security-data-protection-concept-a727981247a79256af4cfab793d5322d.jpg";